export default __webpack_public_path__ + "static/studyoffice-lounge4-ca3d8f30ee27f3199e9c257f6107bf51.jpg";